import React from 'react'
import { FeatureImage } from 'js/components/FeatureImage'
import { lpImages } from 'js/pages/LandingPages/imageSources'

const Stars = () => {
  return (
    <div className="flex items-center gap-x-[4px]">
      <FeatureImage image={lpImages.starIcon} />
      <FeatureImage image={lpImages.starIcon} />
      <FeatureImage image={lpImages.starIcon} />
      <FeatureImage image={lpImages.starIcon} />
      <FeatureImage image={lpImages.starIcon} />
    </div>
  )
}

export default Stars
